// src/Informes/Components/Helpers.js
import React from "react";

export const renderCellContent = (value, defaultValue = "SIN ASOCIACIÓN") => (
  <span className="spanClassForTables centerContent">
    {value?.id ? value.asoc_name || value.zona : defaultValue}
  </span>
);

export const renderCell = (value) => (
  <span className="spanClassForTables centerContent">{value ? value : ""}</span>
);

export const renderNumericValue = (value) => (
  <span className="spanClassForTables centerContent">{value !== 0 ? value : 0}</span>
);

export const getRandomColor = () => {
  const randomColor = Math.floor(Math.random() * 16777215).toString(16);
  return `#${randomColor}`;
};
